import { render, staticRenderFns } from "./label-setting.vue?vue&type=template&id=5000a042&scoped=true&"
import script from "./label-setting.vue?vue&type=script&lang=js&"
export * from "./label-setting.vue?vue&type=script&lang=js&"
import style0 from "./label-setting.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./label-setting.vue?vue&type=style&index=1&id=5000a042&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000a042",
  null
  
)

export default component.exports